/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioVersionParameterType } from './InternalApiScenarioVersionParameterType';
import {
    InternalApiScenarioVersionParameterTypeFromJSON,
    InternalApiScenarioVersionParameterTypeFromJSONTyped,
    InternalApiScenarioVersionParameterTypeToJSON,
    InternalApiScenarioVersionParameterTypeToJSONTyped,
} from './InternalApiScenarioVersionParameterType';
import type { InternalApiScenarioVersionParameterTimeUnit } from './InternalApiScenarioVersionParameterTimeUnit';
import {
    InternalApiScenarioVersionParameterTimeUnitFromJSON,
    InternalApiScenarioVersionParameterTimeUnitFromJSONTyped,
    InternalApiScenarioVersionParameterTimeUnitToJSON,
    InternalApiScenarioVersionParameterTimeUnitToJSONTyped,
} from './InternalApiScenarioVersionParameterTimeUnit';

/**
 * 
 * @export
 * @interface InternalApiScenarioVersionParameter
 */
export interface InternalApiScenarioVersionParameter {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersionParameter
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersionParameter
     */
    displayName: string;
    /**
     * 
     * @type {InternalApiScenarioVersionParameterType}
     * @memberof InternalApiScenarioVersionParameter
     */
    type: InternalApiScenarioVersionParameterType;
    /**
     * 
     * @type {object}
     * @memberof InternalApiScenarioVersionParameter
     */
    value: object;
    /**
     * 
     * @type {InternalApiScenarioVersionParameterTimeUnit}
     * @memberof InternalApiScenarioVersionParameter
     */
    timeUnit?: InternalApiScenarioVersionParameterTimeUnit;
}



/**
 * Check if a given object implements the InternalApiScenarioVersionParameter interface.
 */
export function instanceOfInternalApiScenarioVersionParameter(value: object): value is InternalApiScenarioVersionParameter {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function InternalApiScenarioVersionParameterFromJSON(json: any): InternalApiScenarioVersionParameter {
    return InternalApiScenarioVersionParameterFromJSONTyped(json, false);
}

export function InternalApiScenarioVersionParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioVersionParameter {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'displayName': json['displayName'],
        'type': InternalApiScenarioVersionParameterTypeFromJSON(json['type']),
        'value': json['value'],
        'timeUnit': json['timeUnit'] == null ? undefined : InternalApiScenarioVersionParameterTimeUnitFromJSON(json['timeUnit']),
    };
}

export function InternalApiScenarioVersionParameterToJSON(json: any): InternalApiScenarioVersionParameter {
    return InternalApiScenarioVersionParameterToJSONTyped(json, false);
}

export function InternalApiScenarioVersionParameterToJSONTyped(value?: InternalApiScenarioVersionParameter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'displayName': value['displayName'],
        'type': InternalApiScenarioVersionParameterTypeToJSON(value['type']),
        'value': value['value'],
        'timeUnit': InternalApiScenarioVersionParameterTimeUnitToJSON(value['timeUnit']),
    };
}

